webpackJsonp([6],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+JG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Dashboard_ViewClient__ = __webpack_require__("JKkP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Home_Forms_AccountSelector__ = __webpack_require__("F+jS");












/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* mapFields */])(['tribalId', 'birthdate', 'ssn', 'email', 'password', 'passwordRepeat']), {
    passwordButton: function passwordButton() {
      return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show';
    }
  }),
  data: function data() {
    return {
      showPassword: false,
      model: {
        tribalId: '',
        birthdate: '',
        ssn: '',
        email: '',
        statementEmails: false,
        password: '',
        passwordRepeat: ''
      },
      serverError: '',
      modelValidations: {
        tribalId: {
          required: true,
          alpha_num: true
        },
        birthdate: {
          required: true
        },
        ssn: {
          required: true,
          length: 4,
          decimal: false
        },
        email: {
          email: true
        },
        password: {
          required: true,
          min: 6
        },
        passwordRepeat: {
          confirmed: 'password',
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    updateEmailValidation: function updateEmailValidation() {
      this.$validator.fields.find({ name: 'email' }).rules.required = this.model.statementEmails;
      this.$validator.validate('email');
    },
    validate: function validate() {
      var _this = this;

      this.serverError = false;

      this.$validator.fields.find({ name: 'email' }).rules.required = this.model.statementEmails;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.$emit('on-submit', _this.model);
          _this.register();
        }
      });
    },

    viewClient: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Dashboard_ViewClient__["a" /* default */],
    accountSelector: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Home_Forms_AccountSelector__["a" /* default */],
    register: function register() {
      var _this2 = this;

      this.$http.post('/client/register', this.model).then(function (response) {
        if (response.data.authenticated) {
          if (response.data.accounts) {
            _this2.accountSelector(response.data.accounts);
          } else {
            _this2.viewClient(response.data);
          }
        } else {
          _this2.serverError = response.data.error;
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    this.viewClient = this.viewClient.bind(this);
    this.accountSelector = this.accountSelector.bind(this);
  }
});

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+ghz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Dashboard_ViewClient__ = __webpack_require__("JKkP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Home_Forms_AccountSelector__ = __webpack_require__("F+jS");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* mapFields */])(['tribalId', 'birthdate', 'ssn', 'password', 'passwordRepeat']), {
    passwordButton: function passwordButton() {
      return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show';
    }
  }),
  data: function data() {
    return {
      showPassword: false,
      serverError: false,
      model: {
        tribalId: '',
        birthdate: '',
        ssn: '',
        password: '',
        passwordRepeat: ''
      },
      modelValidations: {
        tribalId: {
          required: true,
          alpha_num: true
        },
        birthdate: {
          required: true
        },
        ssn: {
          required: true,
          length: 4,
          decimal: false
        },
        password: {
          required: true,
          min: 6
        },
        passwordRepeat: {
          required: true,
          confirmed: 'password'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.serverError = false;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.$emit('on-submit', _this.model);
          _this.$http.post('/client/recover', _this.model).then(function (response) {
            if (response.data.authenticated) {
              if (response.data.accounts) {
                _this.accountSelector(response.data.accounts);
              } else {
                _this.viewClient(response.data);
              }
            } else {
              _this.serverError = response.data.error;
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },

    viewClient: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Dashboard_ViewClient__["a" /* default */],
    accountSelector: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Home_Forms_AccountSelector__["a" /* default */]
  },
  created: function created() {
    this.viewClient = this.viewClient.bind(this);
    this.accountSelector = this.accountSelector.bind(this);
  }
});

/***/ }),

/***/ "/8Hc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("Rl7Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f214998_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("xJaH");
function injectStyle (ssrContext) {
  __webpack_require__("sLNj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f214998_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Q/D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "0tbL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrustOverview_vue__ = __webpack_require__("IQ9C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138a7f99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrustOverview_vue__ = __webpack_require__("ENAG");
function injectStyle (ssrContext) {
  __webpack_require__("PkEw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrustOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138a7f99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrustOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "1V4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist__ = __webpack_require__("715g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartist_plugin_legend__ = __webpack_require__("SKZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartist_plugin_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chartist_plugin_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]
  },
  methods: {
    updateChartRange: function updateChartRange(newRange) {
      var _this = this;

      var earningsSelected = [];
      var transactionsSelected = [];
      switch (newRange) {
        case 'all':
          earningsSelected = this.$store.state.userData.marketSum;
          transactionsSelected = this.$store.state.userData.transactionsSum;
          this.chartTimeframe = '<span class="text-muted">Since</span> account opened';
          break;
        case '12months':
          earningsSelected = this.$store.state.userData.marketSum.filter(function (transaction) {
            return transaction.x.isAfter(_this.moment().subtract(12, 'months'));
          });
          transactionsSelected = this.$store.state.userData.transactionsSum.filter(function (transaction) {
            return transaction.x.isAfter(_this.moment().subtract(12, 'months'));
          });
          this.chartTimeframe = '<span class="text-muted">Over the</span> last 12 months';
          break;
        case '3months':
          earningsSelected = this.$store.state.userData.marketSum.filter(function (transaction) {
            return transaction.x.isAfter(_this.moment().subtract(3, 'months'));
          });
          transactionsSelected = this.$store.state.userData.transactionsSum.filter(function (transaction) {
            return transaction.x.isAfter(_this.moment().subtract(3, 'months'));
          });
          this.chartTimeframe = '<span class="text-muted">Over the</span> last 3 months';
          break;
      }

      this.earningsChart.data = {
        series: [earningsSelected]
      };
      this.balanceChart.data = {
        series: [transactionsSelected]
      };
    },
    getYesterday: function getYesterday() {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday;
    }
  },
  mounted: function mounted() {
    var legendSpace = document.getElementById('assetAllocationLegend');
    if (legendSpace) {
      __WEBPACK_IMPORTED_MODULE_2_chartist___default.a.Pie('#assetAllocation', {
        labels: this.$store.state.userData.assetAllocations.map(function (asset) {
          return asset.Category + ' - ' + asset.Percent + '%';
        }),
        series: this.$store.state.userData.assetAllocations.map(function (asset) {
          return asset.Percent;
        })
      }, {
        showLabel: false,
        height: '210px',

        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartist___default.a.plugins.legend({
          clickable: false,
          position: legendSpace
        })]
      });
    }

    if (!this.hasRecentTransaction || this.$store.state.userData.clientData.GroupId === 1) {
      this.chartRange = 'all';
      this.chartRanges = [{
        value: 'all',
        label: 'All Time'
      }];
      this.updateChartRange(this.chartRange);
    }
    if (this.$store.state.userData.UserId) {
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Welcome!',
        text: 'You\'ve successfully logged in! Your User ID is ' + this.$store.state.userData.UserId + ', you can log in directly with it next time.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        type: 'success'
      });
      delete this.$store.state.userData.UserId;
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      chartRanges: [{
        value: 'all',
        label: 'All Time'
      }, {
        value: '12months',
        label: '12 Months'
      }, {
        value: '3months',
        label: '3 Months'
      }],
      chartRange: '12months',
      chartTimeframe: '<span class="text-muted">Over the</span> last 12 months',
      hasRecentTransaction: this.$store.state.userData.marketSum.length > 0 ? this.$store.state.userData.marketSum[this.$store.state.userData.marketSum.length - 1].x.isAfter(this.moment().subtract(4, 'months')) : false,
      earningsChart: {
        data: {
          series: [this.$store.state.userData.marketSum.filter(function (transaction) {
            return transaction.x.isAfter(_this2.moment().subtract(12, 'months'));
          })]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: true,
            showLabel: true,
            type: __WEBPACK_IMPORTED_MODULE_2_chartist___default.a.FixedScaleAxis,
            divisor: 4,
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return _this2.moment(value).format('MMM D, YYYY');
            }
          },
          axisY: {
            offset: 60,
            showGrid: true,
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return (Math.round(parseFloat(value) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).slice(0, -3);
            }
          },
          low: 'auto',
          high: 'auto',
          classNames: {
            line: 'ct-line ct-green'
          }
        }
      },
      balanceChart: {
        data: {
          series: [this.$store.state.userData.transactionsSum.filter(function (transaction) {
            return transaction.x.isAfter(_this2.moment().subtract(12, 'months'));
          })]
        },
        options: {
          showPoint: false,
          lineSmooth: __WEBPACK_IMPORTED_MODULE_2_chartist___default.a.Interpolation.step(),
          height: '210px',
          axisX: {
            showGrid: true,
            showLabel: true,
            type: __WEBPACK_IMPORTED_MODULE_2_chartist___default.a.FixedScaleAxis,
            divisor: 4,
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return _this2.moment(value).format('MMM D, YYYY');
            }
          },
          axisY: {
            offset: 60,
            showGrid: true,
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return (Math.round(parseFloat(value) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).slice(0, -3);
            }
          },
          low: 'auto',
          high: 'auto',
          classNames: {
            line: 'ct-line ct-blue'
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");






var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "2Nt4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728763b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("XwRa");
function injectStyle (ssrContext) {
  __webpack_require__("AwkR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728763b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a897e218_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("EtGq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a897e218_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewCard_vue__ = __webpack_require__("gxM9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3ca4462_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewCard_vue__ = __webpack_require__("cmgb");
function injectStyle (ssrContext) {
  __webpack_require__("UUtB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3ca4462"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3ca4462_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5WM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__("UWg4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e6aa17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__("CUXM");
function injectStyle (ssrContext) {
  __webpack_require__("xv0L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e6aa17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7BS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementLogin_vue__ = __webpack_require__("iil1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac83860_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementLogin_vue__ = __webpack_require__("8wK2");
function injectStyle (ssrContext) {
  __webpack_require__("u20k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac83860_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8aJR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8wK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2"},[_c('div',{class:'banner-' + _vm.getEnvironment(),attrs:{"id":"environment-ribbon"}},[_vm._v("\n    "+_vm._s(_vm.getEnvironmentText())+"\n  ")]),_vm._v(" "),_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Management Username")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.userId),expression:"modelValidations.userId"},{name:"model",rawName:"v-model",value:(_vm.model.userId),expression:"model.userId"}],staticClass:"form-control input-no-border",attrs:{"type":"text","placeholder":"Username","name":"userId"},domProps:{"value":(_vm.model.userId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "userId", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.userId.invalid),expression:"userId.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('userId'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control input-no-border",attrs:{"type":"password","placeholder":"Password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('password'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-wd",attrs:{"disabled":_vm.loading,"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validate($event)}}},[_c('i',{staticClass:"ti-lock"}),_vm._v(" Sign In")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loading)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-pulse"}),_vm._v(" Signing in...")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.serverError)?_c('p',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.serverError))]):_vm._e()])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title pull-left"},[_vm._v("Account Management Login")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AOpe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.change]}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Arw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Trust Overview',
  icon: 'ti-home',
  path: '/management/trustoverview',
  PFTC: false
}, {
  name: 'View Account',
  icon: 'ti-eye',
  path: '/management/accountview'
}, {
  name: 'Recent Distributions',
  icon: 'ti-agenda',
  path: '/management/recentdistributions',
  PFTC: false
}, {
  name: 'Recent Contributions',
  icon: 'ti-agenda',
  path: '/management/recentcontributions',
  PFTC: false
}, {
  name: 'Forms and Pamphlets',
  icon: 'ti-clipboard',
  path: '/dashboard/documents',
  PFTC: false
}, {
  name: 'Manage Users',
  icon: 'fa fa-users',
  path: '/management/managers',
  role: 'Admin'
}, {
  name: 'Reports',
  icon: 'ti-envelope',

  role: 'Admin',
  PFTCOnly: true,
  report: true,
  children: [{
    name: 'Assigned Accounts',
    icon: 'ti-envelope',
    path: '/management/reports/assigned-accounts'
  }, {
    name: 'Electronic Statements',
    icon: 'ti-envelope',
    path: '/management/reports/electronic-statements'
  }]
}]);

/***/ }),

/***/ "AwkR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BRE2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){_vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BXxt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CPUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2"},[_c('div',{class:'banner-' + _vm.getEnvironment(),attrs:{"id":"environment-ribbon"}},[_vm._v("\n    "+_vm._s(_vm.getEnvironmentText())+"\n  ")]),_vm._v(" "),_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title pull-left"},[_vm._v("Recover Account")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-fill btn-wd pull-right",attrs:{"to":"/"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" Back to Login")])],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.tribalId),expression:"modelValidations.tribalId"},{name:"model",rawName:"v-model",value:(_vm.model.tribalId),expression:"model.tribalId"}],staticClass:"form-control input-no-border",attrs:{"type":"text","placeholder":"Personal Tribal ID","name":"tribalId"},domProps:{"value":(_vm.model.tribalId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "tribalId", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tribalId.invalid),expression:"tribalId.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('tribalId'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Birthdate")]),_c('br'),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.birthdate),expression:"modelValidations.birthdate"}],attrs:{"name":"birthdate","type":"date","placeholder":"YYYY-MM-DD","editable":false,"default-value":new Date().getFullYear() - 12 + '-01-01'},model:{value:(_vm.model.birthdate),callback:function ($$v) {_vm.$set(_vm.model, "birthdate", $$v)},expression:"model.birthdate"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.birthdate.invalid),expression:"birthdate.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('birthdate'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last 4 Digits of Social Security Number")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.ssn),expression:"modelValidations.ssn"},{name:"model",rawName:"v-model",value:(_vm.model.ssn),expression:"model.ssn"}],staticClass:"form-control input-no-border",attrs:{"type":"number","placeholder":"XXXX","name":"ssn"},domProps:{"value":(_vm.model.ssn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ssn", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.ssn.invalid),expression:"ssn.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('ssn'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Account Password")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model.lazy",value:(_vm.model.password),expression:"model.password",modifiers:{"lazy":true}}],staticClass:"form-control input-no-border",attrs:{"type":!_vm.showPassword ? 'password' : 'text',"placeholder":"Password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"change":function($event){_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn form-btn",attrs:{"type":"button","tabindex":"-1"},domProps:{"innerHTML":_vm._s(_vm.passwordButton)},on:{"click":function($event){$event.preventDefault();_vm.showPassword=!_vm.showPassword}}})])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('password'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Repeat Account Password")]),_vm._v(" "),((!_vm.showPassword ? 'password' : 'text')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.passwordRepeat),expression:"modelValidations.passwordRepeat"},{name:"model",rawName:"v-model",value:(_vm.model.passwordRepeat),expression:"model.passwordRepeat"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Repeat Password","name":"passwordRepeat","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.passwordRepeat)?_vm._i(_vm.model.passwordRepeat,null)>-1:(_vm.model.passwordRepeat)},on:{"change":function($event){var $$a=_vm.model.passwordRepeat,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model.passwordRepeat=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model.passwordRepeat=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.model, "passwordRepeat", $$c)}}}}):((!_vm.showPassword ? 'password' : 'text')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.passwordRepeat),expression:"modelValidations.passwordRepeat"},{name:"model",rawName:"v-model",value:(_vm.model.passwordRepeat),expression:"model.passwordRepeat"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Repeat Password","name":"passwordRepeat","type":"radio"},domProps:{"checked":_vm._q(_vm.model.passwordRepeat,null)},on:{"change":function($event){_vm.$set(_vm.model, "passwordRepeat", null)}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.passwordRepeat),expression:"modelValidations.passwordRepeat"},{name:"model",rawName:"v-model",value:(_vm.model.passwordRepeat),expression:"model.passwordRepeat"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Repeat Password","name":"passwordRepeat","type":!_vm.showPassword ? 'password' : 'text'},domProps:{"value":(_vm.model.passwordRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "passwordRepeat", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordRepeat.invalid),expression:"passwordRepeat.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('passwordRepeat'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validate($event)}}},[_c('i',{staticClass:"ti-lock"}),_vm._v(" Recover Account")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.serverError)?_c('p',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.serverError))]):_vm._e()])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Tribal ID "),_c('small',[_vm._v("(Numbers Only)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CUXM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search transactions","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"width":column.width,"fixed":column.fixed,"show-overflow-tooltip":true,"prop":column.prop,"label":column.label,"formatter":column.formatter}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1),_vm._v(" "),(_vm.to === _vm.total)?_c('div',[_vm._v("\n          You've reached the end of your account activity.  If you have older account activity that is not shown, please contact Providence First Trust Company.\n        ")]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Transactions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CXf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Managers_vue__ = __webpack_require__("yBzC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f32e356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Managers_vue__ = __webpack_require__("Q9tU");
function injectStyle (ssrContext) {
  __webpack_require__("beYX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Managers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f32e356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Managers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ckg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_ViewClient__ = __webpack_require__("JKkP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Home_Forms_AccountSelector__ = __webpack_require__("F+jS");







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['userId', 'password']), {
    passwordButton: function passwordButton() {
      return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show';
    }
  }),
  data: function data() {
    return {
      showPassword: false,
      loading: false,
      serverError: false,
      model: {
        userId: '',
        password: ''
      },
      modelValidations: {
        userId: {
          required: true,
          alpha_num: true
        },
        password: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.serverError = false;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.$emit('on-submit', _this.model);
          _this.$http.post('/client/login', _this.model).then(function (response) {
            if (response.data.authenticated) {
              if (response.data.accounts) {
                _this.accountSelector(response.data.accounts);
              } else {
                _this.$gtag.set('user_properties', {
                  user_id: 'c' + response.data.clientData.ClientId,
                  group_name: response.data.clientData.GroupName
                });
                _this.viewClient(response.data);
              }
            } else {
              _this.serverError = response.data.error;
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    },

    viewClient: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_ViewClient__["a" /* default */],
    accountSelector: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Home_Forms_AccountSelector__["a" /* default */]
  },
  created: function created() {
    this.viewClient = this.viewClient.bind(this);
    this.accountSelector = this.accountSelector.bind(this);
  }
});

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
      SidebarStore.managementSidebarLinks = options.managementSidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E6JT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"logo-mini",attrs:{"to":"/dashboard/overview"}},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":"static/img/pf-icon.png","alt":""}})])]),_vm._v(" "),_c('router-link',{staticClass:"logo-normal hidden-sm hidden-xs",attrs:{"to":"/dashboard/overview"}},[_c('img',{staticStyle:{"margin-left":"3px"},attrs:{"src":"static/img/pf-logo-text.png","alt":""}})]),_vm._v(" "),_c('router-link',{staticClass:"logo-normal img-responsive visible-sm visible-xs",staticStyle:{"margin-left":"0px"},attrs:{"to":"/dashboard/overview"}},[_c('img',{attrs:{"src":"static/img/pf-logo.png","alt":""}})])],1),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[((_vm.$store.state.userData && (!_vm.$route.path.includes('management') || (_vm.$route.path.includes('documents') && _vm.$store.state.managerData))))?_c('p',{staticClass:"text-center",staticStyle:{"color":"#CCC"}},[_vm._v("User ID: "+_vm._s(_vm.$store.state.userData.emailSettings.LoginId || 'Unassigned'))]):_vm._e(),_vm._v(" "),_c('ul',{class:_vm.navClasses + ' user'},[_vm._l((_vm.userLinks),function(link,index){return ((!link.managerOnly || ((!_vm.$route.path.includes('management') && _vm.$store.state.managerData && _vm.$store.state.userData))) && !(link.path.includes('settings') && _vm.$store.state.managerData &&  _vm.$store.state.userData && (_vm.$store.state.managerData.GroupId !== 0 || !_vm.$store.state.userData.emailSettings.hasOwnProperty('LoginId')) ))?_c('sidebar-item',{key:link.name + index,attrs:{"link":link}}):_vm._e()}),_vm._v(" "),_c('li',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.signOut}},[_vm._m(0)])],2),_vm._v(" "),(_vm.$store.state.userData && !_vm.$route.path.includes('management'))?_c('p',{staticClass:"text-center",staticStyle:{"color":"#CCC"}},[_vm._v(_vm._s(_vm.$store.state.userData.clientData.TrustName))]):_vm._e(),_vm._v(" "),(_vm.$store.state.managerData && !_vm.$store.state.userData && (_vm.$route.path.includes('management')||_vm.$route.path.includes('documents')) && _vm.$store.state.managerData.GroupId !== 0)?_c('p',{staticClass:"text-center",staticStyle:{"color":"#CCC"}},[_vm._v(_vm._s(_vm.$store.state.managerData.groups[0].TrustName))]):_vm._e(),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return (!(link.PFTC === false && _vm.$store.state.managerData.GroupId === 0) && (typeof link.role == 'undefined' || (_vm.$store.state.managerData.Role == 'Admin' && (_vm.$store.state.managerData && (_vm.$store.state.managerData.GroupId === 0 || !link.PFTCOnly)))))?_c('sidebar-item',{key:link.name + index,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})})):_vm._e()}))],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('i',{staticClass:"fa fa-sign-out"}),_vm._v(" "),_c('p',[_vm._v("Sign Out")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EFgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.userData)?_c('div',{staticClass:"row"},[(_vm.$store.state.userData.statements.length === 0)?_c('div',{staticClass:"col-sm-12 text-center"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.state.userData.statements),function(statement,key){return _c('div',{key:key,staticClass:"col-sm-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n              "+_vm._s(statement.substring(7))+"\n            ")]),_vm._v(" "),_c('h6',[_vm._v("Download:")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill text-center pull-left",staticStyle:{"margin-bottom":"5px"},on:{"click":function($event){_vm.downloadStatement(statement)}}},[_c('span',{staticClass:"ti-download"}),_vm._v(" Statement")]),_vm._v(" "),(_vm.$store.state.userData.inserts[key])?_c('button',{staticClass:"btn btn-fill text-center pull-left",staticStyle:{"margin-left":"5px"},on:{"click":function($event){_vm.downloadInsert(statement)}}},[_c('span',{staticClass:"ti-download"}),_vm._v(" Insert")]):_vm._e()])])])])])}),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":[{'test': 5}],"border":""}})],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h2',[_vm._v("No Online Statements Available")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3"},[_c('div',{staticClass:"text-center icon-danger",staticStyle:{"font-size":"6em","width":"inherit"}},[_c('i',{staticClass:"fa fa-file-pdf-o"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ENAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('overview-card',[_c('div',{staticClass:"text-left card-title",staticStyle:{"margin-top":"0em"},attrs:{"slot":"header"},slot:"header"},[_vm._v("\n           Overview\n        ")]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Overall Balance")]),_vm._v("\n          "+_vm._s((parseFloat(( _vm.data.overview.overallBalance) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Active Participants")]),_vm._v("\n          "+_vm._s(_vm.data.overview.activeParticipants.toLocaleString('en-US'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Median Balance")]),_vm._v("\n          "+_vm._s((parseFloat((_vm.data.overview.medianBalance) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("\n          As of "+_vm._s(_vm.moment(_vm.getYesterday()).format('MMMM D, YYYY'))+",\n          pending investment gains/losses posted at month end\n        ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('summary-card',[_c('span',{attrs:{"slot":"title-content"},slot:"title-content"},[_c('span',{staticClass:"text-left card-title",attrs:{"slot":"title"},slot:"title"},[_vm._v("Summary")]),_vm._v(" "),_c('span',{staticClass:"pull-right",attrs:{"slot":"title-label"},slot:"title-label"},[_c('el-select',{staticClass:"select-success",attrs:{"size":"small"},on:{"change":function($event){_vm.updateSummaryRange($event)}},model:{value:(_vm.summaryRange),callback:function ($$v) {_vm.summaryRange=$$v},expression:"summaryRange"}},_vm._l((_vm.summaryRanges),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"trustOverviewSummary",attrs:{"slot":"title-content"},slot:"title-content"},[_c('table',{class:[this.summaryLoading ? 'opaque' : ''],staticStyle:{"width":"100%"}},[_c('tr',[_c('td',[_c('strong',[_vm._v("Beginning Balance as of "+_vm._s(_vm.moment(_vm.data.summary.dateStart).format('MMMM D, YYYY'))+": ")])]),_vm._v(" "),_c('td',{staticClass:"amt"},[_vm._v("\n                "+_vm._s((parseFloat((_vm.data.summary.startBalance) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ))+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"inner"},[_vm._v("\n                Contributions\n              ")]),_vm._v(" "),_c('td',{staticClass:"amt"},[_vm._v("\n                "+_vm._s((parseFloat((_vm.data.summary.contributions) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ))+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"inner"},[_vm._v("\n                Distributions\n              ")]),_vm._v(" "),_c('td',{staticClass:"amt"},[_vm._v("\n                "+_vm._s((parseFloat((_vm.data.summary.distributions) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ))+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"inner"},[_vm._v("\n                Earnings\n              ")]),_vm._v(" "),_c('td',{staticClass:"amt"},[_vm._v("\n                "+_vm._s((parseFloat((_vm.data.summary.earnings) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ))+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"inner"},[_vm._v("\n                Fees\n              ")]),_vm._v(" "),_c('td',{staticClass:"amt"},[_vm._v("\n                "+_vm._s((parseFloat((_vm.data.summary.fees) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ))+"\n              ")])]),_vm._v(" "),_c('tr',{staticStyle:{"border-top":"1px solid #000"}},[_c('td',[_c('strong',[_vm._v("Ending Balance as of "+_vm._s(_vm.moment(_vm.data.summary.dateEnd).format('MMMM D, YYYY'))+": ")])]),_vm._v(" "),_c('td',{staticClass:"amt"},[_vm._v("\n                "+_vm._s((parseFloat((_vm.data.summary.endBalance) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ))+"\n              ")])])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EtGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F+jS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = accountSelector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);



function accountSelector(accounts, formData) {
  var _this = this;

  var accountSelections = {};
  accounts.forEach(function (account) {
    var accountTotal = account.transactions.reduce(function (sum, transaction) {
      return Math.round(sum + parseFloat(transaction.TransAmount));
    }, 0);
    var formattedTotal = (Math.round(accountTotal * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    accountSelections[account.clientData.ClientId] = account.clientData.TrustName + ' - Balance: ' + formattedTotal;
  });

  __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
    title: 'Select An Account to View',
    input: 'select',
    buttonsStyling: false,
    inputOptions: accountSelections,
    confirmButtonClass: 'btn btn-success btn-fill',
    preConfirm: function preConfirm(accountSelected) {
      return selectAccount.call(_this, accountSelected);
    }
  });
}

function selectAccount(clientId) {
  var _this2 = this;

  var loginData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model, { clientId: clientId });
  return this.$http.post('/client/login', loginData).then(function (response) {
    if (response.data.authenticated) {
      if (response.data.accounts) {
        _this2.accountSelector(response.data.accounts, _this2.model);
      } else {
        _this2.viewClient(response.data);
      }
    } else {
      _this2.serverError = response.data.error;
    }
  }).catch(function (error) {
    console.log(error);
  });
}

/***/ }),

/***/ "FPcO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search clients","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-sm-1"},[_c('h5',[(_vm.searching)?_c('i',{staticClass:"fa fa-spinner fa-pulse"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('el-select',{staticClass:"select-success",attrs:{"size":"small"},on:{"change":function($event){_vm.updatePerPage($event)}},model:{value:(_vm.searchLimit),callback:function ($$v) {_vm.searchLimit=$$v},expression:"searchLimit"}},_vm._l((_vm.searchLimits),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"default-sort":_vm.getDefaultSort(),"border":""},on:{"sort-change":_vm.updateSortOrder}},[_c('template',{slot:"empty"},[_c('p',[_vm._v("Search for a client by first or last name or exact tribal ID")])]),_vm._v(" "),_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"formatter":column.formatter,"sortable":"custom"}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50,"label":"View"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-info btn-icon like",on:{"click":function($event){_vm.lookupClient(props.row.ClientId)}}},[_c('i',{staticClass:"ti-eye"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.fromDisplay)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('el-pagination',{staticClass:"pull-right",attrs:{"layout":"prev, pager, next","page-size":this.perPage,"total":this.total},on:{"current-change":_vm.updatePageNumber}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Account Overview',
  icon: 'ti-home',
  path: '/dashboard/overview'
}, {
  name: 'Transaction History',
  icon: 'ti-agenda',
  path: '/dashboard/transactions'
}, {
  name: 'Forms and Pamphlets',
  icon: 'ti-clipboard',
  path: '/dashboard/documents'
}, {
  name: 'Statements',
  icon: 'ti-archive',
  path: '/dashboard/statements'
}]);

/***/ }),

/***/ "GAW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('router-link',{staticClass:"navbar-left",attrs:{"to":"/"}},[_c('img',{staticClass:"img-responsive hidden-xs",attrs:{"src":"static/img/pf-logo.png","alt":"Providence First - Trust Company"}}),_vm._v(" "),_c('img',{staticClass:"img-responsive visible-xs",attrs:{"src":"static/img/pf-icon.png","alt":"Providence First - Trust Company"}})])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-7.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"full-page-background",staticStyle:{"background-image":"url(static/img/background/background-7.jpg)"}})])]),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('a',{attrs:{"href":"http://www.providencefirst.com/?page_id=256","target":"_blank"}},[_vm._v("About")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://www.providencefirst.com/?page_id=251","target":"_blank"}},[_vm._v("Contact")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © "),_c('a',{attrs:{"href":"http://www.providencefirst.com/","target":"_blank"}},[_vm._v("Providence First Trust Company")]),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"font-size":"90%"},attrs:{"href":"static/files/PFTC_Online_Portal_Terms_Conditions.pdf","target":"_blank"}},[_vm._v("Terms & Conditions")]),_vm._v(" | \n            "),_c('a',{staticStyle:{"font-size":"90%"},attrs:{"href":"static/files/PFTC_Online_Portal_Privacy_Policy.pdf","target":"_blank"}},[_vm._v("Privacy Policy")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('a',{attrs:{"href":"http://www.providencefirst.com/?page_id=256","target":"_blank"}},[_vm._v("About")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://www.providencefirst.com/?page_id=251","target":"_blank"}},[_vm._v("Contact Us")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GDj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);








__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    downloadStatement: function downloadStatement(statement) {
      var _this = this;

      this.$http({
        url: '/client/downloadStatement/' + statement,
        method: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        _this.downloadFile(response, statement + ' - ' + _this.$store.state.userData.clientData.AuthCode + _this.$store.state.userData.clientData.TribalId + ' Statement.pdf');
      });
    },
    downloadInsert: function downloadInsert(statement) {
      var _this2 = this;

      this.$http({
        url: '/client/downloadInsert/' + statement,
        method: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        _this2.downloadFile(response, statement + ' - ' + _this2.$store.state.userData.clientData.AuthCode + ' Insert.pdf');
      });
    },
    downloadFile: function downloadFile(file, name) {
      var blob = new Blob([file.data], { type: 'application/pdf' });
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, name);
      } else {
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
      }
    }
  }
});

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37fcfc6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("sPBA");
function injectStyle (ssrContext) {
  __webpack_require__("QI6p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37fcfc6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IQ9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_OverviewCard_vue__ = __webpack_require__("5FB2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_SummaryCard_vue__ = __webpack_require__("je9e");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],

    OverviewCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_OverviewCard_vue__["a" /* default */],
    SummaryCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_SummaryCard_vue__["a" /* default */]
  },
  methods: {
    getYesterday: function getYesterday() {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday;
    },

    getInfo: function getInfo() {
      var _this = this;

      if (this.$store.state.managerData.GroupId !== 0) {
        var url = '/manager/groups/' + this.$store.state.managerData.GroupId + '/overview';
        this.$http.get(url).then(function (response) {
          _this.data.overview = {
            'overallBalance': response.data.overallBalance,
            'activeParticipants': response.data.activeParticipants,
            'medianBalance': response.data.medianBalance
          };
        });
      } else {
        url = '/manager/viewGroup/1';
        this.$http.get(url).then(function (response) {
          _this.data = response.data;
        });
      }
    },
    updateSummaryRange: function updateSummaryRange(event) {
      var _this2 = this;

      if (this.$store.state.managerData.GroupId !== 0) {
        this.summaryLoading = true;
        var url = '/manager/groups/' + this.$store.state.managerData.GroupId + '/summary/' + this.summaryRange;
        this.$http.get(url).then(function (response) {
          _this2.data.summary = response.data.totals;
          _this2.data.summary.dateStart = response.data.dateStart;
          _this2.data.summary.dateEnd = response.data.dateEnd;
          _this2.data.summary.loaded = true;
          _this2.summaryLoading = false;
        });
      } else {
        url = '/manager/group/1/summary/' + this.summaryRange;
        this.$http.get(url).then(function (response) {
          _this2.data = response.data;
        });
      }
    }
  },
  mounted: function mounted() {
    this.data.overview = this.$store.state.managerData.overview;

    if (this.$store.state.managerData.GroupId === 1) {
      this.summaryRange = 'all';
      this.summaryRanges = this.summaryRanges.splice(4, 1);
    }

    if (!this.data.summary.loaded) {
      this.updateSummaryRange({});
    }
  },
  data: function data() {
    return {
      data: {
        overview: {
          overallBalance: 0,
          activeParticipants: 0,
          medianBalance: 0
        },
        summary: {
          startBalance: 0,
          contributions: 0,
          distributions: 0,
          earnings: 0,
          fees: 0,
          endBalance: 0,
          loaded: false
        }
      },
      summaryRanges: [{
        value: '1',
        label: '1 Month'
      }, {
        value: '3',
        label: '3 Months'
      }, {
        value: 'ytd',
        label: 'YTD'
      }, {
        value: '1yr',
        label: '1 Year'
      }, {
        value: 'all',
        label: 'All Time'
      }],
      summaryRange: '1',
      summaryLoading: false
    };
  }
});

/***/ }),

/***/ "JKkP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = viewClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function viewClient(clientData) {
  this.$store.state.userData = clientData;

  this.$store.state.userData.total = clientData.transactions.reduce(function (sum, transaction) {
    return Math.round((sum + parseFloat(transaction.TransAmount)) * 100) / 100;
  }, 0);

  this.$store.state.userData.market = clientData.transactions.filter(function (transaction) {
    return transaction.TransType === 'MK';
  });

  var transactions = this.$store.state.userData.transactions.map(function (transaction) {
    return { x: __WEBPACK_IMPORTED_MODULE_0_moment___default()(transaction.TransDate, 'YYYY-MM-DD'), y: parseFloat(transaction.TransAmount) };
  }).sort(function (left, right) {
    return left.x.diff(right.x);
  });

  var transactionsSum = transactions.length > 0 ? [{ x: transactions[0].x, y: transactions[0].y }] : [];
  for (var i = 1; i < transactions.length; i++) {
    if (transactionsSum[transactionsSum.length - 1].x.isSame(transactions[i].x)) {
      transactionsSum[transactionsSum.length - 1].y += transactions[i].y;
    } else {
      transactionsSum.push({ x: transactions[i].x, y: transactions[i].y + transactionsSum[transactionsSum.length - 1].y });
    }
  }

  if (this.$store.state.userData.clientData.GroupId === 1) {
    var earliestMk = Math.min.apply(Math, this.$store.state.userData.market.map(function (transaction) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(transaction.TransDate, 'YYYY-MM-DD');
    }));
    transactionsSum = transactionsSum.filter(function (transaction) {
      return transaction.x.isAfter(earliestMk);
    });
  }

  this.$store.state.userData.transactionsSum = transactionsSum;

  var market = this.$store.state.userData.market.map(function (transaction) {
    return { x: __WEBPACK_IMPORTED_MODULE_0_moment___default()(transaction.TransDate, 'YYYY-MM-DD'), y: parseFloat(transaction.TransAmount) };
  }).sort(function (left, right) {
    return left.x.diff(right.x);
  });

  var marketSum = market.length > 0 ? [{ x: market[0].x, y: market[0].y }] : [];
  for (var _i = 1; _i < market.length; _i++) {
    if (market[_i].x.isSame(marketSum[marketSum.length - 1].x)) {
      marketSum[marketSum.length - 1].y = marketSum[marketSum.length - 1].y + market[_i].y;
    } else {
      marketSum.push({ x: market[_i].x, y: market[_i].y + marketSum[marketSum.length - 1].y });
    }
  }

  this.$store.state.userData.marketSum = marketSum;

  this.$router.push('/dashboard/overview');
}

/***/ }),

/***/ "L3fZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L8FK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LC7J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LHlB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LRYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M8Ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{class:'banner-' + _vm.getEnvironment(),attrs:{"id":"environment-ribbon"}},[_vm._v("\n    "+_vm._s(_vm.getEnvironmentText())+"\n  ")]),_vm._v(" "),_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$route.path.includes('management') || (_vm.$route.path.includes('documents') && _vm.$store.state.managerData && !_vm.$store.state.userData) ? _vm.$sidebar.managementSidebarLinks : _vm.$sidebar.sidebarLinks}}),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){_vm.toggleSidebar($event)}}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74cd8ab1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ySuJ");
function injectStyle (ssrContext) {
  __webpack_require__("LHlB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74cd8ab1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ffa65e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("e24H");
function injectStyle (ssrContext) {
  __webpack_require__("WCPY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ffa65e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    },
    userLinks: function userLinks() {
      return [{
        name: 'Profile Settings',
        icon: 'ti-settings',
        path: !this.$route.path.includes('management') ? '/dashboard/settings' : '/management/settings'
      }, {
        name: 'Return to Management',
        icon: 'fa fa fa-gavel',
        path: this.$store.state.managerData && this.$store.state.managerData.GroupId !== 0 ? '/management/trustoverview' : '/management/accountview',
        managerOnly: true
      }];
    }
  },
  methods: {
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "ieps"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Fiov"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    signOut: function signOut() {
      var _this2 = this;

      this.$http.post(!this.$store.state.managerData ? '/client/logout' : '/manager/logout').then(function (response) {
        if (response.data.logout) {
          if (_this2.$store.state.managerData) {
            _this2.$store.state.managerData = null;
            _this2.$store.state.userData = null;
            _this2.$router.push('/managementLogin');
          } else {
            _this2.$store.state.userData = null;
            _this2.$router.push('/');
          }
        }
      });
    },
    resizeResponse: function resizeResponse() {
      if (document.documentElement.clientWidth < 1250 && !this.$sidebar.isMinimized) {
        this.$sidebar.toggleMinimize();
      }
      if (document.documentElement.clientWidth >= 1250 && this.$sidebar.isMinimized) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
    window.addEventListener('resize', this.resizeResponse);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
    window.removeEventListener('resize', this.resizeResponse);
  }
});

/***/ }),

/***/ "NFzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2"},[_c('div',{class:'banner-' + _vm.getEnvironment(),attrs:{"id":"environment-ribbon"}},[_vm._v("\n    "+_vm._s(_vm.getEnvironmentText())+"\n  ")]),_vm._v(" "),_c('form',{attrs:{"method":"#","action":"#"},on:{"click":function($event){_vm.serverError = ''}}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title pull-left"},[_vm._v("Account Setup")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-fill btn-wd pull-right",attrs:{"to":"/"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" Back to Login")])],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.tribalId),expression:"modelValidations.tribalId"},{name:"model",rawName:"v-model.lazy",value:(_vm.model.tribalId),expression:"model.tribalId",modifiers:{"lazy":true}}],staticClass:"form-control input-no-border",attrs:{"type":"text","placeholder":"Personal Tribal ID","name":"tribalId"},domProps:{"value":(_vm.model.tribalId)},on:{"change":function($event){_vm.$set(_vm.model, "tribalId", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.tribalId.invalid),expression:"tribalId.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('tribalId'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Birthdate")]),_c('br'),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.birthdate),expression:"modelValidations.birthdate"}],attrs:{"name":"birthdate","type":"date","placeholder":"YYYY-MM-DD","editable":false,"default-value":new Date().getFullYear() - 12 + '-01-01'},model:{value:(_vm.model.birthdate),callback:function ($$v) {_vm.$set(_vm.model, "birthdate", $$v)},expression:"model.birthdate"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.birthdate.invalid),expression:"birthdate.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('birthdate'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last 4 Digits of Social Security Number")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.ssn),expression:"modelValidations.ssn"},{name:"model",rawName:"v-model.lazy",value:(_vm.model.ssn),expression:"model.ssn",modifiers:{"lazy":true}}],staticClass:"form-control input-no-border",attrs:{"type":"number","placeholder":"XXXX","name":"ssn"},domProps:{"value":(_vm.model.ssn)},on:{"change":function($event){_vm.$set(_vm.model, "ssn", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.ssn.invalid),expression:"ssn.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('ssn'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("E-mail (required if going paperless)")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model.lazy",value:(_vm.model.email),expression:"model.email",modifiers:{"lazy":true}}],staticClass:"form-control input-no-border",attrs:{"type":"text","placeholder":"Email Address","name":"email"},domProps:{"value":(_vm.model.email)},on:{"change":function($event){_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('email'))+"\n          ")])]),_vm._v(" "),_c('p-checkbox',{on:{"change":function($event){_vm.updateEmailValidation()}},model:{value:(_vm.model.statementEmails),callback:function ($$v) {_vm.$set(_vm.model, "statementEmails", $$v)},expression:"model.statementEmails"}},[_vm._v("\n          Go paperless and receive statements online only"),_c('br'),_vm._v(" "),_c('small',[_vm._v("By checking this box you agree to the terms in our "),_c('a',{attrs:{"href":"static/files/PFTC_Online_Portal_Paperless_Disclosure.pdf","target":"_blank"}},[_vm._v("Paperless Disclosure")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Account Password")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model.lazy",value:(_vm.model.password),expression:"model.password",modifiers:{"lazy":true}}],staticClass:"form-control input-no-border",attrs:{"type":!_vm.showPassword ? 'password' : 'text',"placeholder":"Password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"change":function($event){_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn form-btn",attrs:{"type":"button","tabindex":"-1"},domProps:{"innerHTML":_vm._s(_vm.passwordButton)},on:{"click":function($event){$event.preventDefault();_vm.showPassword=!_vm.showPassword}}})])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('password'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Repeat Account Password")]),_vm._v(" "),((!_vm.showPassword ? 'password' : 'text')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.passwordRepeat),expression:"modelValidations.passwordRepeat"},{name:"model",rawName:"v-model",value:(_vm.model.passwordRepeat),expression:"model.passwordRepeat"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Repeat Password","name":"passwordRepeat","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.passwordRepeat)?_vm._i(_vm.model.passwordRepeat,null)>-1:(_vm.model.passwordRepeat)},on:{"change":function($event){var $$a=_vm.model.passwordRepeat,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model.passwordRepeat=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model.passwordRepeat=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.model, "passwordRepeat", $$c)}}}}):((!_vm.showPassword ? 'password' : 'text')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.passwordRepeat),expression:"modelValidations.passwordRepeat"},{name:"model",rawName:"v-model",value:(_vm.model.passwordRepeat),expression:"model.passwordRepeat"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Repeat Password","name":"passwordRepeat","type":"radio"},domProps:{"checked":_vm._q(_vm.model.passwordRepeat,null)},on:{"change":function($event){_vm.$set(_vm.model, "passwordRepeat", null)}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.passwordRepeat),expression:"modelValidations.passwordRepeat"},{name:"model",rawName:"v-model",value:(_vm.model.passwordRepeat),expression:"model.passwordRepeat"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Repeat Password","name":"passwordRepeat","type":!_vm.showPassword ? 'password' : 'text'},domProps:{"value":(_vm.model.passwordRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "passwordRepeat", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordRepeat.invalid),expression:"passwordRepeat.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('passwordRepeat'))+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validate($event)}}},[_c('i',{staticClass:"ti-lock"}),_vm._v(" Setup Account")]),_c('br'),_c('br'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.serverError)?_c('p',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.serverError))]):_vm._e()])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Tribal ID "),_c('small',[_vm._v("(Numbers Only)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NG1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2"},[_c('div',{class:'banner-' + _vm.getEnvironment(),attrs:{"id":"environment-ribbon"}},[_vm._v("\n    "+_vm._s(_vm.getEnvironmentText())+"\n  ")]),_vm._v(" "),_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title pull-left"},[_vm._v("Login")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-fill btn-wd pull-right",attrs:{"to":"/firsttime"}},[_c('i',{staticClass:"ti-key"}),_vm._v(" First Time Login")])],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("User ID")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.userId),expression:"modelValidations.userId"},{name:"model",rawName:"v-model",value:(_vm.model.userId),expression:"model.userId"}],staticClass:"form-control input-no-border",attrs:{"type":"text","placeholder":"User ID","name":"userId"},domProps:{"value":(_vm.model.userId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "userId", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.userId.invalid),expression:"userId.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('userId'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[((!_vm.showPassword ? 'password' : 'text')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Password","name":"password","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.password)?_vm._i(_vm.model.password,null)>-1:(_vm.model.password)},on:{"change":function($event){var $$a=_vm.model.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model.password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model.password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.model, "password", $$c)}}}}):((!_vm.showPassword ? 'password' : 'text')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Password","name":"password","type":"radio"},domProps:{"checked":_vm._q(_vm.model.password,null)},on:{"change":function($event){_vm.$set(_vm.model, "password", null)}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control input-no-border",attrs:{"placeholder":"Password","name":"password","type":!_vm.showPassword ? 'password' : 'text'},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn form-btn",attrs:{"type":"button","tabindex":"-1"},domProps:{"innerHTML":_vm._s(_vm.passwordButton)},on:{"click":function($event){$event.preventDefault();_vm.showPassword=!_vm.showPassword}}})])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('password'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-wd",attrs:{"disabled":_vm.loading,"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validate($event)}}},[_c('i',{staticClass:"ti-lock"}),_vm._v(" Sign In")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loading)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-pulse"}),_vm._v(" Signing in...")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.serverError)?_c('p',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.serverError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{attrs:{"to":"/recoveraccount"}},[_c('i',{staticClass:"ti-help-alt"}),_vm._v(" Forgot User ID or Password\n            ")])],1)])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtag__ = __webpack_require__("Z3T5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_store_js__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sidebarLinks__ = __webpack_require__("FiZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__managementSidebarLinks__ = __webpack_require__("Arw2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);



























var axiosPlugin = {
  install: function install(Vue) {
    var http = __WEBPACK_IMPORTED_MODULE_17_axios___default.a.create();
    http.defaults.withCredentials = true;
    http.defaults.baseURL = location.protocol + '//' + location.hostname + '/api';
    http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    Vue.prototype.$http = http;
  }
};

var momentPlugin = {
  install: function install(Vue) {
    Vue.prototype.moment = __WEBPACK_IMPORTED_MODULE_20_moment___default.a;
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9__globalComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default.a, { type: 'success', horizontalAlign: 'right', verticalAlign: 'bottom' });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(axiosPlugin);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_18__sidebarLinks__["a" /* default */], managementSidebarLinks: __WEBPACK_IMPORTED_MODULE_19__managementSidebarLinks__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(momentPlugin);
__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a);

var getEnvironmentBanner = {
  install: function install(Vue, options) {
    Vue.prototype.getEnvironment = function () {
      var matches = Vue.prototype.$http.defaults.baseURL.match(/\/api-(.*)$/);
      var part = matches !== null && matches.length === 2 ? matches[1] : null;
      var env;
      if (part === 'dev') {
        env = 'development';
      } else if (part === 'staging') {
        env = 'staging';
      } else {
        env = 'production';
      }
      return env;
    };
    Vue.prototype.getEnvironmentText = function () {
      var env = Vue.prototype.getEnvironment();
      return env.charAt(0).toUpperCase() + env.substr(1);
    };
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(getEnvironmentBanner);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_12__routes_routes__["a" /* default */],
  linkActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.afterEach(function (to, from) {
  if (document.getElementsByClassName('main-panel').length > 0) {
    document.getElementsByClassName('main-panel')[0].scrollTop = 0;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_gtag__["a" /* default */], {
  config: { id: 'G-G1XQQHD09S' }
}, router);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_16__store_store_js__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__App_vue__["a" /* default */]);
  },
  router: router
});

/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  watch: {
    chartData: function chartData(newData, oldData) {
      this.initChart();
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e477f56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("pcxg");
function injectStyle (ssrContext) {
  __webpack_require__("PFLc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e477f56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oyhb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    queriedData: function queriedData() {
      return this.data.data;
    }
  },
  data: function data() {
    return {
      tableColumns: [{
        prop: 'GroupName',
        label: 'Group',
        width: 100
      }, {
        prop: 'TrustName',
        label: 'Trust Name',
        width: 300
      }, {
        prop: 'FirstName',
        label: 'First Name',
        width: 200
      }, {
        prop: 'LastName',
        label: 'Last Name',
        width: 200
      }, {
        prop: 'Email',
        label: 'Email Address'
      }, {
        prop: 'LastStatementDate',
        label: 'Last Statement Date'
      }],

      data: {
        data: []
      }
    };
  },

  methods: {
    getReportData: function getReportData() {
      var _this = this;

      if (this.$store.state.managerData.GroupId === 0) {
        var url = '/reports/emailStatements';

        this.$http.get(url).then(function (response) {
          _this.data.data = response.data;
        });
      }
    },
    redirectToCSV: function redirectToCSV() {
      window.location.href = this.$http.defaults.baseURL + '/reports/emailStatements.csv';
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getReportData();
  }
});

/***/ }),

/***/ "PFLc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PkEw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pnwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);








__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    downloadDocument: function downloadDocument(file) {
      var groupName = this.$store.state.userData ? this.$store.state.userData.clientData.GroupName : this.$store.state.managerData.groups[0].GroupName;
      this.$http({
        url: '/' + (this.$store.state.managerData ? 'manager' : 'client') + '/downloadDocument/' + file.ID,
        method: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, groupName + ' - ' + file.Name + '.pdf');
        } else {
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', groupName + ' - ' + file.Name + '.pdf');

          document.body.appendChild(link);
          link.click();
        }
      });
    }
  }
});

/***/ }),

/***/ "Q9tU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.editForm.name),expression:"editForm.name",modifiers:{"lazy":true}},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"John Doe","name":"name"},domProps:{"value":(_vm.editForm.name)},on:{"change":function($event){_vm.$set(_vm.editForm, "name", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.name.invalid),expression:"name.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('name'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.editForm.email),expression:"editForm.email",modifiers:{"lazy":true}},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"example@examplesite.com","name":"email"},domProps:{"value":(_vm.editForm.email)},on:{"change":function($event){_vm.$set(_vm.editForm, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('email'))+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.editForm.username),expression:"editForm.username",modifiers:{"lazy":true}},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.username),expression:"modelValidations.username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"jdoe","name":"username"},domProps:{"value":(_vm.editForm.username)},on:{"change":function($event){_vm.$set(_vm.editForm, "username", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.username.invalid),expression:"username.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('username'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model.lazy",value:(_vm.editForm.password),expression:"editForm.password",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"name":"password","type":!_vm.showPassword ? 'password' : 'text'},domProps:{"value":(_vm.editForm.password)},on:{"change":function($event){_vm.$set(_vm.editForm, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"border-color":"#DDD"},attrs:{"tabindex":"-1","type":"button"},on:{"click":function($event){$event.preventDefault();_vm.editForm.password=_vm.randomWord(8)}}},[_c('i',{staticClass:"ti-key"}),_vm._v(" Generate\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn form-btn",attrs:{"tabindex":"-1","type":"button"},domProps:{"innerHTML":_vm._s(_vm.passwordButton)},on:{"click":function($event){$event.preventDefault();_vm.showPassword=!_vm.showPassword}}})])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('password'))+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[(_vm.$store.state.managerData.GroupId===0)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Group")]),_c('br'),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.group),expression:"modelValidations.group"}],staticClass:"select-success",attrs:{"filterable":"","name":"group","placeholder":"Select Group","size":"small"},model:{value:(_vm.editForm.group),callback:function ($$v) {_vm.$set(_vm.editForm, "group", $$v)},expression:"editForm.group"}},[_c('el-option',{attrs:{"label":"PFTC","value":"0"}}),_vm._v(" "),_vm._l((_vm.$store.state.managerData.groups),function(group){return _c('el-option',{key:group.GroupId,attrs:{"label":group.GroupName,"value":group.GroupId}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.group.invalid),expression:"group.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('group'))+"\n              ")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Role")]),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-success",attrs:{"size":"small"},model:{value:(_vm.editForm.role),callback:function ($$v) {_vm.$set(_vm.editForm, "role", $$v)},expression:"editForm.role"}},[_c('el-option',{attrs:{"label":"Manager","value":"Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Admin","value":"Admin"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validate($event)}}},[_vm._v("Create New "+_vm._s(_vm.editForm.role))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search managers","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"}),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"formatter":column.formatter}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Delete","width":"70","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button',{staticClass:"btn btn-sm btn-fill btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.deleteManager(scope.row)}}},[_vm._v("X")])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.resultTotal)+" of "+_vm._s(_vm.total)+" managers")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("New Management")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Current Management")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QClq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"width":column.width,"fixed":column.fixed,"show-overflow-tooltip":true,"prop":column.prop,"label":column.label,"formatter":column.formatter}})}))],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Assigned Accounts By Group")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QI6p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_572e051d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("E6JT");
function injectStyle (ssrContext) {
  __webpack_require__("/Q/D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_572e051d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rl7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);











__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showPassword: false,
      showCurrentPassword: false,
      serverError: false,
      model: {
        clientId: this.$route.path.includes('management') ? this.$store.state.managerData.ID : this.$store.state.userData.clientData.ClientId,
        email: this.$route.path.includes('management') ? this.$store.state.managerData.Email : this.$store.state.userData.emailSettings.Email || '',
        password: '',
        currentPassword: '',
        statementEmails: this.$route.path.includes('management') ? '' : !!this.$store.state.userData.emailSettings.EmailStatements
      },
      modelValidations: {
        email: {
          email: true
        },
        password: {
          min: 6
        },
        currentPassword: {
          required: true
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* mapFields */])(['email', 'password', 'passwordRepeat', 'currentPassword']), {
    passwordButton: function passwordButton() {
      return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show';
    },
    currentPasswordButton: function currentPasswordButton() {
      return this.showCurrentPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show';
    }
  }),
  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model));
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    updateEmailValidation: function updateEmailValidation() {
      this.$validator.fields.find({ name: 'email' }).rules.required = this.model.statementEmails;
      this.$validator.validate('email');
    },
    validate: function validate() {
      var _this = this;

      this.serverError = false;

      this.$validator.fields.find({ name: 'email' }).rules.required = this.model.statementEmails;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.$emit('on-submit', _this.model);
          _this.$http.post(_this.$route.path.includes('management') ? '/manager/update' : '/client/updateAccount', _this.model).then(function (response) {
            if (response.data.success === true) {
              _this.model.currentPassword = _this.model.password = '';
              if (!_this.$route.path.includes('management')) {
                _this.$store.state.userData.emailSettings = response.data.emailSettings;
              }
              _this.$notify({
                component: {
                  template: '<span><b>Success</b> - Account settings updated.</span>'
                },
                icon: 'ti-check',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'success'
              });
              _this.$nextTick(function () {
                return _this.$validator.reset();
              });
            } else {
              throw response.data.error;
            }
          }).catch(function (error) {
            _this.serverError = error;
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_Overview_vue__ = __webpack_require__("uFAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Home_Home_vue__ = __webpack_require__("rQVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Home_Forms_Login_vue__ = __webpack_require__("iQ+t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Home_Forms_AccountSetup_vue__ = __webpack_require__("ba+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Home_Forms_RecoverAccount_vue__ = __webpack_require__("kesw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Home_Forms_ManagementLogin_vue__ = __webpack_require__("7BS3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Management_TrustOverview_vue__ = __webpack_require__("0tbL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Management_RecentDistributions_vue__ = __webpack_require__("UJSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Management_RecentContributions_vue__ = __webpack_require__("i41f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Management_AccountView_vue__ = __webpack_require__("dH4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Management_Managers_vue__ = __webpack_require__("CXf2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Management_Reports_AssignedAccounts_vue__ = __webpack_require__("shjH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Management_Reports_ElectronicStatements_vue__ = __webpack_require__("lfFA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Documents_vue__ = __webpack_require__("W4Bh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Dashboard_Settings_Settings_vue__ = __webpack_require__("/8Hc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Transactions_vue__ = __webpack_require__("5WM5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Statements_vue__ = __webpack_require__("a7xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_store_store_js__ = __webpack_require__("wtEF");





























var routes = [{
  path: '/signout',
  redirect: '/'
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Home_Home_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Home_Forms_Login_vue__["a" /* default */]
  }, {
    path: '/firsttime',
    name: 'Account Setup',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Home_Forms_AccountSetup_vue__["a" /* default */]
  }, {
    path: '/recoveraccount',
    name: 'Recover Account',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Home_Forms_RecoverAccount_vue__["a" /* default */]
  }, {
    path: '/managementlogin',
    name: 'Management Login',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Home_Forms_ManagementLogin_vue__["a" /* default */]
  }]
}, {
  path: '/dashboard',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_19_src_store_store_js__["a" /* default */].state.userData && __WEBPACK_IMPORTED_MODULE_19_src_store_store_js__["a" /* default */].state.userData.clientData || to.path.includes('/dashboard/document') && __WEBPACK_IMPORTED_MODULE_19_src_store_store_js__["a" /* default */].state.managerData) {
      next();
    } else {
      next('/');
    }
  },
  children: [{
    path: 'overview',
    name: 'Account Overview',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_Overview_vue__["a" /* default */]
  }, {
    path: 'transactions',
    name: 'Transaction History',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Transactions_vue__["a" /* default */]
  }, {
    path: 'documents',
    name: 'Forms and Pamphlets',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Documents_vue__["a" /* default */]
  }, {
    path: 'statements',
    name: 'Statements',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Statements_vue__["a" /* default */]
  }, {
    path: 'settings',
    name: 'Profile Settings',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Dashboard_Settings_Settings_vue__["a" /* default */]
  }]
}, {
  path: '/management',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_19_src_store_store_js__["a" /* default */].state.managerData) {
      if ((to.path === '/management/trustoverview' || to.path === '/management/accountview') && __WEBPACK_IMPORTED_MODULE_19_src_store_store_js__["a" /* default */].state.userData && __WEBPACK_IMPORTED_MODULE_19_src_store_store_js__["a" /* default */].state.userData.clientData) {
        __WEBPACK_IMPORTED_MODULE_19_src_store_store_js__["a" /* default */].state.userData = null;
      }
      next();
    } else {
      next('/managementLogin');
    }
  },
  children: [{
    path: 'managers',
    name: 'Manage Users',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Management_Managers_vue__["a" /* default */]
  }, {
    path: 'trustoverview',
    name: 'Trust Overview',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Management_TrustOverview_vue__["a" /* default */]
  }, {
    path: 'recentdistributions',
    name: 'Recent Distributions',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Management_RecentDistributions_vue__["a" /* default */]
  }, {
    path: 'recentcontributions',
    name: 'Recent Contributions',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Management_RecentContributions_vue__["a" /* default */]
  }, {
    path: 'accountview',
    name: 'View Account',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Management_AccountView_vue__["a" /* default */]
  }, {
    path: 'settings',
    name: 'Manager Settings',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Dashboard_Settings_Settings_vue__["a" /* default */]
  }, {
    path: 'reports',
    name: 'Reports',

    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: 'assigned-accounts',
      name: 'Reports',
      component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Management_Reports_AssignedAccounts_vue__["a" /* default */]
    }, {
      path: 'electronic-statements',
      name: 'Reports',
      component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Management_Reports_ElectronicStatements_vue__["a" /* default */]
    }]
  }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("v2o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea018080_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("BRE2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea018080_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    idleLogout: function idleLogout() {
      var _this = this;

      var signOut = function signOut() {
        window.removeEventListener('mousemove', resetTimer, true);
        window.removeEventListener('mousedown', resetTimer, true);
        window.removeEventListener('touchstart', resetTimer, true);
        window.removeEventListener('click', resetTimer, true);
        window.removeEventListener('keypress', resetTimer, true);
        window.removeEventListener('scroll', resetTimer, true);
        _this.$http.post(_this.$http.defaults.baseURL + '/client/logout').then(function (response) {
          if (_this.$store.state.managerData) {
            _this.$store.state.managerData = null;
            _this.$store.state.userData = null;
            _this.$router.push('/managementLogin');
          } else {
            _this.$store.state.userData = null;
            _this.$router.push('/');
          }
        });
      };

      var timeSinceMovement = setTimeout(signOut, 600000);

      var resetTimer = function resetTimer() {
        clearTimeout(timeSinceMovement);
        timeSinceMovement = setTimeout(signOut, 600000);
      };

      window.addEventListener('mousemove', resetTimer, true);
      window.addEventListener('mousedown', resetTimer, true);
      window.addEventListener('touchstart', resetTimer, true);
      window.addEventListener('click', resetTimer, true);
      window.addEventListener('keypress', resetTimer, true);
      window.addEventListener('scroll', resetTimer, true);
    }
  },
  mounted: function mounted() {
    this.idleLogout();
  }
});

/***/ }),

/***/ "UJSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecentDistributions_vue__ = __webpack_require__("d0IO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d1610a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecentDistributions_vue__ = __webpack_require__("ck2Z");
function injectStyle (ssrContext) {
  __webpack_require__("eeO0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecentDistributions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d1610a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecentDistributions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UUtB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UWg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);

















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      console.log(this.$store.state.userData);
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      var result = this.tableData.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (key === 'TransDate') {
              rowValue = _this.moment(rowValue).format('MM/DD/YYYY');
            }
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      pagination: {
        perPage: 15,
        currentPage: 1,
        perPageOptions: [5, 10, 15, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['TransDate', 'TransAmount', 'TransPayee'],
      tableColumns: [{
        prop: 'TransDate',
        label: 'Date',
        width: 110,
        formatter: function formatter(row, column, cellValue) {
          return _this2.moment(cellValue).format('MM/DD/YYYY');
        }
      }, {
        prop: 'TransPayee',
        label: 'Description',
        minWidth: 200
      }, {
        prop: 'TransAmount',
        label: 'Amount',
        fixed: 'right',
        minWidth: 100,
        formatter: function formatter(row, column, cellValue) {
          return (Math.round(parseFloat(cellValue) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        }
      }],
      tableData: this.$store.state.userData.transactions ? this.$store.state.userData.clientData.GroupId === 1 ? this.$store.state.userData.transactions.filter(function (transaction) {
        return transaction.TransType !== 'MK' && __WEBPACK_IMPORTED_MODULE_12_moment___default()(transaction.TransDate, 'YYYY-MM-DD').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_12_moment___default()('2014/01/01', 'YYYY-MM-DD'));
      }) : this.$store.state.userData.transactions.filter(function (transaction) {
        return transaction.TransType !== 'MK';
      }) : []
    };
  },

  methods: {}
});

/***/ }),

/***/ "Ud7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"pull-left",staticStyle:{"font-size":"1.5em"}},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "W4Bh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documents_vue__ = __webpack_require__("Pnwc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f62d8ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documents_vue__ = __webpack_require__("tVWO");
function injectStyle (ssrContext) {
  __webpack_require__("LC7J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f62d8ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WCPY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WktI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XwRa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-header",staticStyle:{"width":"calc(100%-1000px)"}},[_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(_vm.$route.name))])]),_vm._v(" "),_c('div',{staticClass:"fullname"},[_vm._v(_vm._s(_vm.$store.state.userData ? (_vm.$store.state.userData.clientData.FirstName + ' ' + _vm.$store.state.userData.clientData.LastName) : "")+"\n    ")]),_vm._v(" "),((_vm.$route.path.includes('management') || (_vm.$route.path.includes('documents') && _vm.$store.state.managerData && !_vm.$store.state.userData)) && _vm.$store.state.managerData.GroupId !== 0)?_c('span',{staticClass:"groupname"},[_vm._v("\n      "+_vm._s(_vm.$store.state.managerData.groups[0].TrustName)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a359449_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("mby7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a359449_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a7xh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statements_vue__ = __webpack_require__("GDj4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_810083bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statements_vue__ = __webpack_require__("EFgB");
function injectStyle (ssrContext) {
  __webpack_require__("h8O/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_810083bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ba+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSetup_vue__ = __webpack_require__("+JG/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd939b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSetup_vue__ = __webpack_require__("NFzz");
function injectStyle (ssrContext) {
  __webpack_require__("WktI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSetup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd939b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSetup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "beYX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1f39d4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("LRYI");
function injectStyle (ssrContext) {
  __webpack_require__("8aJR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1f39d4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cLHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"pull-left",staticStyle:{"font-size":"1.5em"}},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ck2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},on:{"change":function($event){_vm.updateTable($event)}},model:{value:(_vm.limits.period),callback:function ($$v) {_vm.$set(_vm.limits, "period", $$v)},expression:"limits.period"}},_vm._l((_vm.limits.periods),function(item){return _c('el-option',{key:item.value,staticClass:"select-default",attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search transactions","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"padding-right":"1em"}},[_c('div',[_c('strong',[_vm._v("Total:")]),_vm._v(" "),_c('span',{staticClass:"totals-value"},[_vm._v(" "+_vm._s((Math.round(parseFloat(this.data.totals.amount) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })))])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Transactions:")]),_vm._v(" "),_c('span',{staticClass:"totals-value"},[_vm._v(" "+_vm._s(this.data.totals.entries.toLocaleString('en-US')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"width":column.width,"fixed":column.fixed,"show-overflow-tooltip":true,"prop":column.prop,"label":column.label,"formatter":column.formatter}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(this.data.from === null ? 0 : this.data.from)+" to "+_vm._s(this.data.to === null ? 0 : this.data.to)+" of "+_vm._s(this.data.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('el-pagination',{staticClass:"pull-right",attrs:{"layout":"prev, pager, next","page-size":this.data.per_page,"total":this.data.total},on:{"current-change":function($event){_vm.updateLimit($event)}}})],1)]),_vm._v(" "),(this.$store.state.managerData.GroupId === 1 && this.data.to === this.data.total)?_c('div',[_vm._v("\n        You've reached the end of your account activity.  If you have older account activity that is not shown, please contact Providence First Trust Company.\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Transactions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cmgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-2"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cqan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    queriedData: function queriedData() {
      return this.data.data;
    }
  },
  data: function data() {
    return {
      tableColumns: [{
        prop: 'GroupName',
        label: 'Name',
        width: 200
      }, {
        prop: 'UserCount',
        label: 'Assigned Accounts',
        minWidth: 110
      }],

      data: {
        data: []
      }
    };
  },

  methods: {
    getReportData: function getReportData() {
      var _this = this;

      if (this.$store.state.managerData.GroupId === 0) {
        var url = '/reports/byGroup/assignedAccounts';

        this.$http.get(url).then(function (response) {
          _this.data.data = response.data;
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getReportData();
  }
});

/***/ }),

/***/ "d0IO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);














__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery || this.searchQuery.length < 2) {
        if (this.data.data === null || this.previousQuery !== this.searchQuery) {
          this.updateTable();
          this.previousQuery = this.searchQuery;
        }
      } else if (this.previousQuery !== this.searchQuery) {
        this.previousQuery = this.searchQuery;
        this.searchCount++;
        var currentCheck = this.searchCount;
        setTimeout(function () {
          if (_this.searchQuery.length >= 2 && _this.searchCount === currentCheck) {
            _this.updateTable();
          }
        }, 200);
      }
      return this.data.data;
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      limits: {
        period: '30',
        periods: [{
          value: '30',
          label: '30 days'
        }, {
          value: '90',
          label: '90 days'
        }, {
          value: '12mo',
          label: 'Last 12 Months'
        }, {
          value: 'ytd',
          label: 'YTD'
        }, {
          value: 'all',
          label: 'All Time'
        }]
      },
      searchQuery: '',
      previousQuery: null,
      searchCount: 0,
      tableColumns: [{
        prop: 'TransDate',
        label: 'Date',
        width: 110,
        formatter: function formatter(row, column, cellValue) {
          return _this2.moment(cellValue).format('MM/DD/YYYY');
        }
      }, {
        prop: 'Name',
        label: 'Name',
        width: 200
      }, {
        prop: 'TribalId',
        label: 'Tribal ID',
        minWidth: 110
      }, {
        prop: 'TransPayee',
        label: 'Description',
        minWidth: 200
      }, {
        prop: 'TransAmount',
        label: 'Amount',
        fixed: 'right',
        minWidth: 100,
        formatter: function formatter(row, column, cellValue) {
          return (Math.round(parseFloat(cellValue) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        }
      }],

      data: {
        per_page: 100,
        from: 0,
        to: 0,
        total: 0,
        data: []
      },
      pagination: {
        currentPage: 1,
        perPage: 100
      }
    };
  },

  methods: {
    updateLimit: function updateLimit(limit) {
      this.pagination.currentPage = limit;
      this.updateTable();
    },
    updateTable: function updateTable() {
      this.getTransactionData();
    },
    getTransactionData: function getTransactionData() {
      var _this3 = this;

      if (this.$store.state.managerData.GroupId !== 0) {
        var url = '/manager/groups/' + this.$store.state.managerData.GroupId + '/distributions/' + this.limits.period;

        url += '?page=' + this.pagination.currentPage + '&limit=' + this.pagination.perPage;
        url += '&q=' + this.searchQuery;

        this.$http.get(url).then(function (response) {
          _this3.data = response.data;
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getTransactionData();
  }
});

/***/ }),

/***/ "dH4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountView_vue__ = __webpack_require__("ts5v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72df5b66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountView_vue__ = __webpack_require__("FPcO");
function injectStyle (ssrContext) {
  __webpack_require__("2Nt4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72df5b66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_158d340e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("cLHK");
function injectStyle (ssrContext) {
  __webpack_require__("wv4D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_158d340e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dkLA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e24H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"http://www.providencefirst.com","target":"_blank"}},[_vm._v("\n            ProvidenceFirst.com\n          ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://www.providencefirst.com/?page_id=256","target":"_blank"}},[_vm._v("\n            About\n          ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://www.providencefirst.com/?page_id=251","target":"_blank"}},[_vm._v("\n            Contact\n          ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"static/files/PFTC_Online_Portal_Terms_Conditions.pdf","target":"_blank"}},[_vm._v("Terms & Conditions")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"static/files/PFTC_Online_Portal_Privacy_Policy.pdf","target":"_blank"}},[_vm._v("Privacy Policy")])])])]),_vm._v(" "),_c('div',{staticClass:"copyright pull-right"},[_vm._v("\n      © Providence First Trust Company\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb6877e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("M8Ae");
function injectStyle (ssrContext) {
  __webpack_require__("dkLA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb6877e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "eeO0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g9mV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.userData)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center icon-success",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-wallet"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Total Balance")]),_vm._v("\n          "+_vm._s((_vm.$store.state.userData.total ? (Math.round(_vm.$store.state.userData.total * 100) / 100) : 0)
                  .toLocaleString('en-US', { style: 'currency', currency: 'USD' }))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("\n          As of "+_vm._s(_vm.moment(_vm.getYesterday()).format('MMMM D, YYYY'))+",\n          pending investment gains/losses posted at month end\n        ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center icon-success",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-stats-up"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("Total Earnings")]),_vm._v("\n          "+_vm._s((Math.round(parseFloat(_vm.$store.state.userData.marketSum[_vm.$store.state.userData.marketSum.length - 1].y) * 100) / 100)
            .toLocaleString('en-US', { style: 'currency', currency: 'USD' }))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("\n          Since Enrollment or Transfer\n        ")])])],1)]),_vm._v(" "),(_vm.$store.state.userData.assetAllocations.length > 0 && _vm.hasRecentTransaction)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_vm._m(0),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_c('div',{staticClass:"card-footer stats"},[_c('hr'),_vm._v("\n          As of "+_vm._s(_vm.moment(_vm.$store.state.userData.assetAllocations[0].Date).format('MMMM D, YYYY'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_vm._m(2),_vm._v(" "),_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.$store.state.userData.investmentReturns}},[_c('el-table-column',{attrs:{"label":"Time Period","min-width":"200","property":"Period"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Gain/Loss","width":"100","property":"Return","align":"right","formatter":function (row,col,cell) { return cell + '%'; }}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":" ","width":"10"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"card-footer stats"},[_vm._v("\n          As of "+_vm._s(_vm.moment(_vm.$store.state.userData.investmentReturns[0].Date).format('MMMM D, YYYY'))+"\n        ")])])])]):_vm._e(),_vm._v(" "),(_vm.$store.state.userData.market.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.balanceChart.data,"chart-options":_vm.balanceChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n            Balance History\n          ")]),_vm._v(" "),_c('span',{attrs:{"slot":"title-label"},slot:"title-label"},[_c('el-select',{staticClass:"select-success",attrs:{"size":"small"},on:{"change":function($event){_vm.updateChartRange($event)}},model:{value:(_vm.chartRange),callback:function ($$v) {_vm.chartRange=$$v},expression:"chartRange"}},_vm._l((_vm.chartRanges),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},domProps:{"innerHTML":_vm._s(_vm.chartTimeframe)},slot:"subtitle"})])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.earningsChart.data,"chart-options":_vm.earningsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n            Earnings History\n          ")]),_vm._v(" "),_c('span',{attrs:{"slot":"title-label"},slot:"title-label"},[_c('el-select',{staticClass:"select-success",attrs:{"size":"small"},on:{"change":function($event){_vm.updateChartRange($event)}},model:{value:(_vm.chartRange),callback:function ($$v) {_vm.chartRange=$$v},expression:"chartRange"}},_vm._l((_vm.chartRanges),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},domProps:{"innerHTML":_vm._s(_vm.chartTimeframe)},slot:"subtitle"})])],1)]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"pull-left col-xs-12",staticStyle:{"font-size":"1.5em"}},[_vm._v("\n                Asset Allocation\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"ct-chart ct-chart-pie",attrs:{"id":"assetAllocation"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5",attrs:{"id":"assetAllocationLegend"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"pull-left",staticStyle:{"font-size":"1.5em","padding-left":"15px"}},[_vm._v("\n                Fund Investment Performance\n              ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gxM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'overview-card'
});

/***/ }),

/***/ "gzCl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"width":column.width,"fixed":column.fixed,"show-overflow-tooltip":true,"prop":column.prop,"label":column.label,"formatter":column.formatter}})}))],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"button"},on:{"click":_vm.redirectToCSV}},[_vm._v("Export CSV")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Electronic Statements")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8O/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i41f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecentContributions_vue__ = __webpack_require__("mbHh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c5677fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecentContributions_vue__ = __webpack_require__("k3Qw");
function injectStyle (ssrContext) {
  __webpack_require__("vs0B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecentContributions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c5677fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecentContributions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iQ+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("Ckg5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_961c2aa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("NG1K");
function injectStyle (ssrContext) {
  __webpack_require__("tZmH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_961c2aa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iil1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['userId', 'password'])),
  data: function data() {
    return {
      serverError: false,
      loading: false,
      model: {
        userId: '',
        password: ''
      },
      modelValidations: {
        userId: {
          required: true,
          alpha_num: true
        },
        password: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.serverError = false;
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.$emit('on-submit', _this.model);
          _this.$http.post('/manager/login', _this.model).then(function (response) {
            if (!response.data.authenticated) {
              throw response.data.error;
            }
            _this.$store.state.managerData = response.data.user;
            _this.$gtag.set('user_properties', {
              user_id: 'm' + response.data.user.ID,
              group_name: response.data.user.groups[0].GroupName
            });
            if (_this.$store.state.managerData.GroupId !== 0) {
              _this.$router.push({ path: '/management/trustoverview' });
            } else {
              _this.$router.push({ path: '/management/accountview' });
            }
          }).catch(function (error) {
            _this.serverError = error;
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);



/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "je9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryCard_vue__ = __webpack_require__("u+TS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4934a718_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryCard_vue__ = __webpack_require__("Ud7G");
function injectStyle (ssrContext) {
  __webpack_require__("vkaH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4934a718_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jru2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k3Qw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},on:{"change":function($event){_vm.updateTable($event)}},model:{value:(_vm.limits.period),callback:function ($$v) {_vm.$set(_vm.limits, "period", $$v)},expression:"limits.period"}},_vm._l((_vm.limits.periods),function(item){return _c('el-option',{key:item.value,staticClass:"select-default",attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search transactions","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"padding-right":"1em"}},[_c('div',[_c('strong',[_vm._v("Total:")]),_vm._v(" "),_c('span',{staticClass:"totals-value"},[_vm._v(" "+_vm._s((Math.round(parseFloat(this.data.totals.amount) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })))])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Transactions:")]),_vm._v(" "),_c('span',{staticClass:"totals-value"},[_vm._v(" "+_vm._s(this.data.totals.entries.toLocaleString('en-US')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"width":column.width,"fixed":column.fixed,"show-overflow-tooltip":true,"prop":column.prop,"label":column.label,"formatter":column.formatter}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(this.data.from === null ? 0 : this.data.from)+" to "+_vm._s(this.data.to === null ? 0 : this.data.to)+" of "+_vm._s(this.data.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('el-pagination',{staticClass:"pull-right",attrs:{"layout":"prev, pager, next","page-size":this.data.per_page,"total":this.data.total},on:{"current-change":function($event){_vm.updateLimit($event)}}})],1),_vm._v(" "),(this.$store.state.managerData.GroupId === 1 && this.data.to === this.data.total)?_c('div',[_vm._v("\n          You've reached the end of your account activity.  If you have older account activity that is not shown, please contact Providence First Trust Company.\n        ")]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Transactions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9329cc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("AOpe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9329cc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kesw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverAccount_vue__ = __webpack_require__("+ghz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a408b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverAccount_vue__ = __webpack_require__("CPUF");
function injectStyle (ssrContext) {
  __webpack_require__("L8FK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a408b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElectronicStatements_vue__ = __webpack_require__("Oyhb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d55ceaf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElectronicStatements_vue__ = __webpack_require__("gzCl");
function injectStyle (ssrContext) {
  __webpack_require__("yGFZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElectronicStatements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d55ceaf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElectronicStatements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mG7c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mbHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);














__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery || this.searchQuery.length < 2) {
        if (this.data.data === null || this.previousQuery !== this.searchQuery) {
          this.updateTable();
          this.previousQuery = this.searchQuery;
        }
      } else if (this.previousQuery !== this.searchQuery) {
        this.previousQuery = this.searchQuery;
        this.searchCount++;
        var currentCheck = this.searchCount;
        setTimeout(function () {
          if (_this.searchQuery.length >= 2 && _this.searchCount === currentCheck) {
            _this.updateTable();
          }
        }, 200);
      }
      return this.data.data;
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      limits: {
        period: '30',
        periods: [{
          value: '30',
          label: '30 days'
        }, {
          value: '90',
          label: '90 days'
        }, {
          value: '12mo',
          label: 'Last 12 Months'
        }, {
          value: 'ytd',
          label: 'YTD'
        }, {
          value: 'all',
          label: 'All Time'
        }]
      },
      searchQuery: '',
      previousQuery: null,
      searchCount: 0,
      tableColumns: [{
        prop: 'TransDate',
        label: 'Date',
        width: 110,
        formatter: function formatter(row, column, cellValue) {
          return _this2.moment(cellValue).format('MM/DD/YYYY');
        }
      }, {
        prop: 'Name',
        label: 'Name',
        width: 200
      }, {
        prop: 'TribalId',
        label: 'Tribal ID',
        minWidth: 110
      }, {
        prop: 'TransPayee',
        label: 'Description',
        minWidth: 200
      }, {
        prop: 'TransAmount',
        label: 'Amount',
        fixed: 'right',
        minWidth: 100,
        formatter: function formatter(row, column, cellValue) {
          return (Math.round(parseFloat(cellValue) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        }
      }],

      data: {
        per_page: 100,
        from: 0,
        to: 0,
        total: 0,
        data: []
      },
      pagination: {
        currentPage: 1,
        perPage: 100
      }
    };
  },

  methods: {
    updateLimit: function updateLimit(limit) {
      this.pagination.currentPage = limit;
      this.updateTable();
    },
    updateTable: function updateTable() {
      this.getTransactionData();
    },
    getTransactionData: function getTransactionData() {
      var _this3 = this;

      if (this.$store.state.managerData.GroupId !== 0) {
        var url = '/manager/groups/' + this.$store.state.managerData.GroupId + '/contributions/' + this.limits.period;

        url += '?page=' + this.pagination.currentPage + '&limit=' + this.pagination.perPage;
        url += '&q=' + this.searchQuery;

        this.$http.get(url).then(function (response) {
          _this3.data = response.data;
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getTransactionData();
  }
});

/***/ }),

/***/ "mby7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pcxg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q6wr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "qu3N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rQVu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("q6wr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c88f109_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("GAW7");
function injectStyle (ssrContext) {
  __webpack_require__("BXxt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c88f109_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sLNj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sPBA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",[(_vm.link.path !== 'signOut')?_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_c('i',{class:_vm.link.icon})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2):_vm._e()]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "shjH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignedAccounts_vue__ = __webpack_require__("cqan");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8385a620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignedAccounts_vue__ = __webpack_require__("QClq");
function injectStyle (ssrContext) {
  __webpack_require__("L3fZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignedAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8385a620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignedAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tVWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.userData || _vm.$store.state.managerData)?_c('div',{staticClass:"row"},[((_vm.$store.state.userData && _vm.$store.state.userData.documents.length === 0) && (_vm.$store.state.managerData && _vm.$store.state.managerData.documents.length === 0))?_c('div',{staticClass:"col-sm-12 text-center"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.state.userData ? _vm.$store.state.userData.documents : _vm.$store.state.managerData.documents),function(document){return _c('div',{key:document.ID,staticClass:"col-sm-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(document.Name))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(document.Description))]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill text-center",on:{"click":function($event){_vm.downloadDocument(document)}}},[_c('span',{staticClass:"ti-download"}),_vm._v(" Download")])])])])])])}),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":[{'test': 5}],"border":""}})],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h2',[_vm._v("No Online Documents Available")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3"},[_c('div',{staticClass:"text-center icon-danger",staticStyle:{"font-size":"6em","width":"inherit"}},[_c('i',{staticClass:"fa fa-file-pdf-o"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tZmH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ts5v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Dashboard_ViewClient__ = __webpack_require__("JKkP");



















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery || this.searchQuery.length < 2) {
        if (this.results === null || this.previousQuery !== this.searchQuery) {
          this.refreshData();
          this.previousQuery = this.searchQuery;
        }
      } else if (this.previousQuery !== this.searchQuery) {
        this.previousQuery = this.searchQuery;
        this.searchCount++;
        var currentCheck = this.searchCount;
        setTimeout(function () {
          if (_this.searchQuery.length >= 2 && _this.searchCount === currentCheck) {
            _this.refreshData();
          }
        }, 200);
      }
      return this.tableData;
    },
    to: function to() {
      return !this.results ? 0 : this.results.to;
    },
    from: function from() {
      return !this.results ? 0 : this.results.from;
    },
    fromDisplay: function fromDisplay() {
      return this.from;
    },
    total: function total() {
      return this.results ? this.results.total : 0;
    }
  },
  data: function data() {
    return {
      perPage: 100,
      currentPage: 1,
      searchCount: 0,
      searching: false,
      searchQuery: '',
      sortOrder: 'Name',
      sortDirection: 'ASC',
      searchLimit: 100,
      searchLimits: [{
        value: 100,
        label: '100'
      }, {
        value: 500,
        label: '500'
      }, {
        value: 'all',
        label: 'All'
      }],
      previousQuery: '',
      propsToSearch: ['Name', 'TribalId', 'DOB'],
      tableColumns: [{
        prop: 'Name',
        label: 'Name',
        minWidth: 200
      }, {
        prop: 'TribalId',
        label: 'Tribal ID',
        minWidth: 90
      }, {
        prop: 'DOB',
        label: 'Birthdate',
        minWidth: 110,
        formatter: function formatter(row, column, cellValue) {
          var date = __WEBPACK_IMPORTED_MODULE_13_moment___default()(cellValue, 'YYYY-MM-DD');
          return date.format('MM/DD/YYYY') + ' (' + __WEBPACK_IMPORTED_MODULE_13_moment___default()().diff(date, 'years') + ')';
        }
      }, {
        prop: 'GuardianName',
        label: 'Guardian',
        minWidth: 150
      }, {
        prop: 'SSN',
        label: 'SSN',
        minWidth: 70
      }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.managerData.GroupId === 0 ? [{
        prop: 'GroupName',
        label: 'Tribe',
        minWidth: 120
      }] : [])),
      tableData: [],
      results: null
    };
  },

  methods: {
    viewClient: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Dashboard_ViewClient__["a" /* default */],
    lookupClient: function lookupClient(clientId) {
      var _this2 = this;

      this.$http.get('/manager/viewClient/' + clientId).then(function (response) {
        _this2.viewClient(response.data);
      });
    },
    getDefaultSort: function getDefaultSort() {
      return { prop: this.sortOrder, order: 'ascending' };
    },

    updatePerPage: function updatePerPage(newPerPage) {
      if (this.searchLimit !== 'all') {
        this.perPage = this.searchLimit;
      }
      this.refreshData();
    },

    updateSortOrder: function updateSortOrder(e) {
      this.sortDirection = e.order === 'descending' ? 'DESC' : 'ASC';
      this.sortOrder = e.prop;
      this.refreshData();
    },
    updatePageNumber: function updatePageNumber(val) {
      this.currentPage = val;
      this.refreshData();
    },

    refreshData: function refreshData() {
      var _this3 = this;

      var url = '/manager/searchClients/' + this.sortOrder + '/' + this.sortDirection;
      if (this.searchQuery !== '') {
        url += '/' + this.searchQuery;
      }
      url += '?page=' + this.currentPage + '&limit=' + this.searchLimit;
      this.searching = true;
      this.$http.get(url).then(function (response) {
        _this3.searching = false;
        _this3.results = response.data;
        _this3.tableData = response.data.data;

        if (_this3.searchLimit === 'all') {
          _this3.perPage = _this3.results.total;
        }
      });
    }
  },
  created: function created() {
    this.viewClient = this.viewClient.bind(this);
  }
});

/***/ }),

/***/ "u+TS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'summary-card'
});

/***/ }),

/***/ "u20k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  methods: {
    change: function change() {
      this.$emit('change');
    }
  },
  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uFAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("1V4J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b2b52b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("g9mV");
function injectStyle (ssrContext) {
  __webpack_require__("qu3N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b2b52b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v2o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed033d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("x/yC");
function injectStyle (ssrContext) {
  __webpack_require__("jru2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ed033d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed033d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vkaH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vs0B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9b79b56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("mG7c");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9b79b56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    userForm: {}
  },
  mutations: {
    userData: function userData(state, data) {
      state.userData = data;
    },
    userForm: function userForm(state, form) {
      state.userForm = form;
    },
    managementLevel: function managementLevel(state, level) {
      state.userForm = level;
    }
  }
}));

/***/ }),

/***/ "wv4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x/yC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);




__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "x36W"));
__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "p4sG"));
__webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "UVIz"));
/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var _this = this;

    this.$http.interceptors.request.use(function (config) {
      __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
      return config;
    });

    this.$http.interceptors.response.use(function (response) {
      __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
      return response;
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
      _this.$notify({
        component: {
          template: '<span><b>Connection Error</b> - Could not connect to the Providence First servers, check your connection or try again later.</span>'
        },
        icon: 'ti-alert',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'danger'
      });
      console.log(error);
    });
  }
});

/***/ }),

/***/ "xJaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.managerData || _vm.$store.state.userData)?_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control input-no-border",attrs:{"type":"text","name":"email","placeholder":"No Email Currently Provided"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('email'))+"\n          ")])]),_vm._v(" "),(!_vm.$route.path.includes('management'))?_c('div',{staticClass:"col-md-12"},[(_vm.model.email != '' && !_vm.email.invalid)?_c('p-checkbox',{model:{value:(_vm.model.statementEmails),callback:function ($$v) {_vm.$set(_vm.model, "statementEmails", $$v)},expression:"model.statementEmails"}},[_vm._v("\n            Go paperless and receive statements online"),_c('br'),_vm._v(" "),_c('small',[_vm._v("By checking this box you agree to the terms in our "),_c('a',{attrs:{"href":"static/files/PFTC_Online_Portal_Paperless_Disclosure.pdf","target":"_blank"}},[_vm._v("Paperless Disclosure")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("New Account Password")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model.lazy",value:(_vm.model.password),expression:"model.password",modifiers:{"lazy":true}}],staticClass:"form-control input-no-border",attrs:{"type":!_vm.showPassword ? 'password' : 'text',"placeholder":"Password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"change":function($event){_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn form-btn",attrs:{"type":"button","tabindex":"-1"},domProps:{"innerHTML":_vm._s(_vm.passwordButton)},on:{"click":function($event){$event.preventDefault();_vm.showPassword=!_vm.showPassword}}})])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('password'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('hr'),_vm._v(" "),_c('label',[_vm._v("Enter Your Current Password to Verify Changes")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.currentPassword),expression:"modelValidations.currentPassword"},{name:"model",rawName:"v-model.lazy",value:(_vm.model.currentPassword),expression:"model.currentPassword",modifiers:{"lazy":true}}],staticClass:"form-control input-no-border",attrs:{"type":!_vm.showCurrentPassword ? 'password' : 'text',"name":"currentPassword","placeholder":"Current Password"},domProps:{"value":(_vm.model.currentPassword)},on:{"change":function($event){_vm.$set(_vm.model, "currentPassword", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn form-btn",attrs:{"type":"button","tabindex":"-1"},domProps:{"innerHTML":_vm._s(_vm.currentPasswordButton)},on:{"click":function($event){$event.preventDefault();_vm.showCurrentPassword=!_vm.showCurrentPassword}}})])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPassword.invalid),expression:"currentPassword.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('currentPassword'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validate($event)}}},[_vm._v("\n          Update Profile\n        ")]),_c('br'),_c('br'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.serverError)?_c('p',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.serverError))]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":[{'test': 5}],"border":""}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Edit Profile")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xv0L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yBzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__("sUu7");


















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["b" /* mapFields */])(['name', 'username', 'email', 'password', 'group']), {
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.resultTotal = this.tableData.length;
        return this.tableData;
      }
      var result = this.tableData.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
            if (key === 'GroupId') {
              (function () {
                var groupId = row[key];
                var groupName = groupId === 0 ? 'pftc' : _this.$store.state.managerData.groups.find(function (group) {
                  return group.GroupId === groupId;
                }).GroupName.toLowerCase();
                if (groupName.includes && groupName.includes(_this.searchQuery.toLowerCase())) {
                  isIncluded = true;
                }
              })();
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.resultTotal = result.length;
      return result;
    },
    passwordButton: function passwordButton() {
      return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show';
    },
    total: function total() {
      this.resultTotal = this.tableData.length;
      return this.tableData.length;
    }
  }),
  data: function data() {
    var _this2 = this;

    return {
      showPassword: false,
      resultTotal: 0,
      searchQuery: '',
      editForm: {
        name: '',
        email: '',
        username: '',
        password: '',
        role: 'Manager',
        group: ''
      },
      modelValidations: {
        name: {
          required: true,
          min: 3
        },
        email: {
          email: true,
          required: true
        },
        username: {
          required: true,
          min: 3
        },
        password: {
          min: 6,
          required: true
        },
        group: {
          required: true
        }
      },
      propsToSearch: ['Name', 'Email', 'Role'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.managerData.GroupId === 0 ? ['GroupId'] : [])),
      tableColumns: [{
        prop: 'Name',
        label: 'Name',
        minWidth: 110
      }, {
        prop: 'Username',
        label: 'Username',
        minWidth: 110
      }, {
        prop: 'Email',
        label: 'Email',
        minWidth: 100
      }, {
        prop: 'Role',
        label: 'Role',
        minWidth: 70
      }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.managerData.GroupId === 0 ? [{
        prop: 'GroupId',
        label: 'Group',
        minWidth: 70,
        formatter: function formatter(row, column, cellValue) {
          return cellValue === 0 ? 'PFTC' : _this2.$store.state.managerData.groups.find(function (group) {
            return group.GroupId === cellValue;
          }).GroupName;
        }
      }] : [])),
      tableData: []
    };
  },

  methods: {
    newManager: function newManager() {
      var _this3 = this;

      this.$http.post('/manager/create', this.editForm).then(function (response) {
        _this3.tableData = response.data;
        _this3.editForm = {
          name: '',
          email: '',
          username: '',
          password: '',
          group: '',
          role: 'Manager'
        };
        _this3.$nextTick(function () {
          return _this3.$validator.reset();
        });
        _this3.$notify({
          component: {
            template: '<span><b>Manager Created</b> - The manager was successfully created.</span>'
          },
          icon: 'ti-close',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        });
      });
    },
    deleteManager: function deleteManager(manager) {
      var _this4 = this;

      this.$http.post('/manager/delete', manager).then(function (response) {
        _this4.tableData = response.data;
        _this4.$notify({
          component: {
            template: '<span><b>Manager Deleted</b> - The manager was permanently deleted.</span>'
          },
          icon: 'ti-close',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        });
      });
    },
    randomWord: function randomWord(length) {
      var vowels = ['a', 'e', 'i', 'o', 'u'];
      var consts = ['b', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'r', 's', 't', 'v', 'w', 'y', 'z', 'ch', 'sh', 'th'];
      var word = '';
      var isVowel = false;
      var arr = void 0;

      for (var i = 0; i < length; i++) {
        if (isVowel) {
          arr = vowels;
        } else {
          arr = consts;
        }
        isVowel = !isVowel;
        word += arr[Math.round(Math.random() * (arr.length - 1))];
      }
      return word;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this5 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this5.$emit('on-submit', _this5.model);
          _this5.newManager();
        }
      });
    }
  },
  created: function created() {
    var _this6 = this;

    this.$http.get('/manager/getManagers').then(function (response) {
      _this6.tableData = response.data;
    });
  }
});

/***/ }),

/***/ "yGFZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ySuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ylrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
});

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f82d88dd157a84b00275.js